import styled from 'styled-components';
import Table from '@mlb/react-patterns/v4/components/Table/table';
import { Tabs, TabList } from '@mlb/react-patterns/v4/components/Tabs/tabs';
import { ButtonGroupWrapper } from '@mlb/react-patterns/v4/components/ButtonGroup/buttonGroup.style';
import { StyledTableCell, StyledTableHead } from '@mlb/react-patterns/v4/components/Table/TableCell/table-cell.style';
import BREAKPOINTS from '@mlb/react-patterns/v4/style/breakpoints';
import { ImageWrapper } from '@mlb/react-patterns/v4/components/Image/image.style';
import { GDBREAKPOINTS_FINAL } from '../themes/breakpoints';
import { StyledButton } from '@mlb/react-patterns/v4/components/Button/button.style';
const {SM_MAX, MD_MAX} = GDBREAKPOINTS_FINAL;
export const SkeletonWrapper = styled.div`
    position: relative;
    height: 140px;
    >div {
        position: absolute;
        top: 0px;
        left: 0px;
        &:first-child {
            left: 68px;
        }
        &:nth-child(2) {
            top: 26px;
        }
        &:nth-child(3) {
            top: 82px;
        }
    }
`;

export const SkeletonTabs = styled.div`
    > div {
        margin-right: 33px;
        display: inline-block;
        @media (max-width: ${SM_MAX}) {
            width: 114px;
            &:not(:first-child) {
                display: none;
            }
        }
    }
`;

export const TeamComparisonTabs = styled(Tabs)`
`;

export const TeamComparisonTabList = styled(TabList)`
    padding-bottom: 16px;
`;


export const BoldCell = styled.span`
    font-weight: bold;
    color:  var(--gameday-primary-font-color) !important;
`;

export const TeamComparisonWrapper = styled.div`
    overflow: hidden;
    ${ButtonGroupWrapper} {
        padding-bottom: 16px;
    }

    ${StyledTableCell} {
        font-family: var(--gameday-primary-font);
        width: 100%;
        padding: 0 !important;
        span {
            color: var(--gameday-team-comparison-secondary-font-color);
            font-style: normal;
            font-weight: 700;
            line-height: 27px;

            &.bold {
                font-weight: 800;
                color: var(--gameday-primary-font-color);
            }
        }
    }
    button {
        border: none;
        height: 22px;
        padding: 0 32px 0 0;
        margin-top:6px;

        &:hover {
            border: none;
            border-color: var(--gameday-primary-font-color);
        }

        span {
            color: var(--gameday-tabs-unselected-color);
            border-bottom: 0;
            font-size: 18px;
        }


    }
    [data-selected=true] {
        span {
            color: var(--gameday-primary-font-color);
            border-color: var(--gameday-primary-font-color);
        }
    }

    ${StyledButton} {
        height: 30px;
        font-family: var(--gameday-primary-font);
        font-size: 14px;
        padding: 0 10px;
        border-radius: 18px;
        margin-right: 12px;
        background: var(--gameday-filter-button-bgcolor);
        border: 1px solid var(--gameday-filter-button-border);
        line-height: 16px;
        color: var(--gameday-filter-button-hover-bgcolor); 

        &:last-child {
            margin-right: 0;
        }

        span {
            white-space: nowrap;
            font-size: 14px;
            line-height: 14px;
            font-weight: 700;
            display: block;
            color: var(--gameday-filter-button-fontcolor);
        }

        &[data-selected="true"] {
            background: var(--gameday-filter-button-hover-bgcolor); 
            border: 1px solid var(--gameday-filter-button-hover-border);
            span {
                color: var(--gameday-filter-button-hover-fontcolor);
            }
        }


        @media (hover: hover){
            &:hover {
                background: var(--gameday-filter-button-hover-bgcolor);
                border: 1px solid var(--gameday-filter-button-hover-border);
                span {
                    color: var(--gameday-filter-button-hover-fontcolor) !important;
                }
            }
        }

    }
`;

export const TeamStatsTable = styled(Table)`

    thead {
        th {
            &:first-child{
                width: 24%;
            }

            @media (max-width: ${SM_MAX}) {
                &:first-child{
                    width: 46px;
                }
            }   


        }
    
    tbody {
        td {
            text-transform: uppercase;
        }

        th {
            left: 10px;
            padding-top: 14px;
            padding-bottom: 14px;
        }
    }

    ${StyledTableHead} {
        span {
            font-size: 18px;
            font-weight: bold;
            text-transform: uppercase;
            color: var(--gameday-primary-font-color);
            display: block;
            height: 28px;
        }
    }
`;

export const TitleWrapper = styled.div` 
    padding-bottom: 16px;
    font-size: 24px;
    font-weight: 700;
    font-family: var(--gameday-primary-font);
`;

export const FooterWrapper = styled.div`
    font-size: 13px;
    font-weight: 500;
    font-family: var(--gameday-primary-font);
    color: var(--gameday-team-stats-footer-color);
    text-align: center;
    width: 100%;
`;

export const TeamNameWrapper = styled.div`
    display: inline-block;
    vertical-align: top;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 18px;
    font-weight: bold;
    color: var(--gameday-primary-font-color);
    @media (max-width: ${BREAKPOINTS.md}) {
        margin-left: 10px;
    }

    @media (max-width: ${SM_MAX}) {
        display: none;
    }
`;

export const TeamStatsWrapper = styled.div`
    width: 100%;
    font-family: var(--gameday-primary-font);
    height: 116px;
    @media (max-width: ${SM_MAX}) {
        height: 104px;
    }
    ${ImageWrapper} {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    thead {
        th {
            span {
                font-size: 18px;
                font-weight: bold;
                line-height: 18px;
                
            }
        }
    }
    
    tr {
        :not(:last-child){
            td{
                border-bottom: 1px solid var(--gameday-divider-color);
                padding-bottom: 6px !important;
            }
        }
        :last-child {
            td{
                padding-top: 4px !important;
                padding-bottom: 0px !important;
            }
        }
    }

    ${StyledTableCell} {
        font-size: 18px;
        &:not(:first-child):not(:last-child) {
            width: 12%;
        }
        &:first-child {
            width: 20%;
            @media (max-width: ${SM_MAX}) {
                width: 10%;
            }
        }
        &:last-child {
            width: 6%;
            text-align: right;
        }
        > div {
            display: flex;
            align-items: center;
            justify-content: flex-start;
        }
    }
`;
